import appconfig from '../utils/appconfig';
import axios from 'axios';

const apiEvents = {
    getNextEvent: function () {
        return axios.get('/data/concerts.json')
            .then(function (response) {
                let now = new Date();
                return response.data.filter(concert => new Date(concert.enddatetime) > now);
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    addEvent: function (event, username) {
        const config = {
            headers: { 'username': username },
            data: { ...event }
        }
        return axios.post('https://ffl5xehbf8.execute-api.eu-west-1.amazonaws.com/beta/events', config)
            .then(function (response) {
                alert('Evento inserito');
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    updateEvent: function (event, username) {
        const config = {
            method: 'put',
            headers: { 'username': username },
            data: { event }
        }
        return axios('https://ffl5xehbf8.execute-api.eu-west-1.amazonaws.com/beta/events', config)
            .then(function (response) {
                alert('Evento inserito');
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}

export default apiEvents;


// WEBPACK FOOTER //
// ./src/services/srv-events.js